/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Open_MenuInputs */



/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Layout_Header_Open_MenuInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_open_menu = /** @type {((inputs?: Layout_Header_Open_MenuInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Open_MenuInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Menü öffnen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le menu")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("打开菜单")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("開啟選單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("메뉴 열기")
	return /** @type {LocalizedString} */ ("Open menu")
});